import { bootstrapApplication } from '@angular/platform-browser';
import { initializeApp } from 'firebase/app';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Initialize Firebase before Angular bootstraps
initializeApp(environment.firebaseConfig);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
